export default {
    screenShowSet: {
        method: "POST",
        url: "/adminScreen/screen-user/set-tonglu-screen",
        name: "设置桐庐大屏数据",
    },
    screenShowInfo: {
        method: "POST",
        url: "/adminScreen/screen-user/get-tonglu-screen",
        name: "获取桐庐数据大屏配置",
    },
    screenShowStation: {
        method: "POST",
        url: "/adminScreen/screen-user/station-list",
        name: "点位列表",
    },
    weekList: {
        method: "POST",
        url: "/adminScreen/screen-user/week-list",
        name: "星期列表",
    },
    selectWeekDefault: {
        method: "POST",
        url: "/adminScreen/screen-user/select-week-default",
        name: "置星期使用默认值",
    },
    transportOrderList: {
        method: "POST",
        url: "/adminScreen/screen-user/transport-order-list",
        name: "物流运单列表",
    },
    transportOrderDetail: {
        method: "POST",
        url: "/adminScreen/screen-user/transport-order-detail",
        name: "物流运单详情",
    },
};
